import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import sceneManager from './utils/sceneManager'

import 'amfe-flexible'

import Vant from 'vant'
import 'vant/lib/index.css'

// 加载全局样式
import './styles/index.less'
// 引入字体样式
import "@/styles/font.css";

Vue.use(Vant)

Vue.mixin({
  beforeCreate () {
    const name = this.$options.name || ''
    const isSceneComponent =
      name.startsWith('voiceCall') ||
      name.startsWith('BuyTrainTickets') ||
      name.startsWith('bookHotel')

    if (isSceneComponent && this.$options.methods && this.$options.methods.playSuccessSound && !this.$options.methods.playSuccessSound.__wrapped) {
      const original = this.$options.methods.playSuccessSound
      const wrapped = function (...args) {
        sceneManager.recordSuccess()
        return original.apply(this, args)
      }
      wrapped.__wrapped = true
      this.$options.methods.playSuccessSound = wrapped
    }
    this.__isSceneComponent = isSceneComponent
  },
  mounted () {
    if (
      this.__isSceneComponent &&
      typeof this.startTime !== 'undefined' &&
      window.__evaluationStartTimestamp
    ) {
      this.$nextTick(() => {
        if (typeof this.startTime !== 'undefined') {
          this.startTime = window.__evaluationStartTimestamp
        }
      })
    }
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
